import { HomepageBreadcrumbs, CoverageListBreadcrumbs } from 'ui/Breadcrumbs';

import { regions } from 'shared/constants/regions';
import { businessLines } from 'shared/constants/businessLines';
import {
  CoveredBondsCountryBreadcrumbs,
  CreditRatingCoverageTableCountryBreadcrumb,
  PortfolioItemsBreadcrumbs,
  RSRRatingUsersBreadcrumbs,
  SubscriptionRatingsBreadcrumbs,
} from 'ui/Breadcrumbs/DynamicBreadcrumbs/DynamicBreadcrumbs';
import { useFilterOptions } from 'modules/ESG/services/esgLendingService';

export const breadcrumbsRoutes = [
  {
    path: '/',
    breadcrumb: HomepageBreadcrumbs,
  },
  {
    path: '/issuer-dashboard',
    breadcrumb: null,
  },
  {
    path: '/analysts',
    breadcrumb: 'Analysts',
  },
  {
    path: '/watchlists',
    breadcrumb: 'Portfolios',
  },
  {
    path: '/instruments/:instrumentId',
    breadcrumb: 'Instrument details',
  },
  {
    path: '/entities/:easyNumber/details',
    breadcrumb: 'Entity details',
  },
  {
    path: '/entities/:entityId',
    breadcrumb: 'Entity details',
  },
  {
    path: '/entities/:entityId/instruments/:instrumentId',
    breadcrumb: 'Instrument details',
  },
  {
    path: '/entities/:entityId/announcements/:announcementId',
    breadcrumb: 'Announcement',
  },
  {
    path: '/news-centre',
    breadcrumb: 'News centre',
  },
  {
    path: '/profile',
    breadcrumb: 'Profile',
  },
  {
    path: '/announcements/:announcementId',
    breadcrumb: 'Announcement',
  },
  // Covered Bonds
  {
    path: '/covered-bonds/:country',
    breadcrumb: CoveredBondsCountryBreadcrumbs,
  },
  {
    path: '/covered-bonds/:country/instruments/:instrumentId',
    breadcrumb: 'Instruments details',
  },
  // Search result
  {
    path: '/search-result/entities/:easyNumber',
    breadcrumb: 'Entity details',
  },
  {
    path: '/search-result/entities/:entityId/instruments/:instrumentId',
    breadcrumb: 'Instrument details',
  },
  {
    path: '/search-result/entities/:entityId/instruments/:instrumentId/announcements/:announcementId',
    breadcrumb: 'Announcement',
  },
  {
    path: '/search-result/entities/:entityId/announcements/:announcementId',
    breadcrumb: 'Announcement',
  },
  {
    path: '/search-result/entities/:entityId',
    breadcrumb: 'Entity details',
  },
  {
    path: '/search-result/instruments/:instrumentId',
    breadcrumb: 'Instruments details',
  },
  {
    path: '/search-result/announcements/:announcementId',
    breadcrumb: 'Announcement',
  },
  {
    path: '/search-result',
    breadcrumb: 'Search result',
  },
  // /Search result
  // Portfolio
  {
    path: '/portfolios/:portfolioId/entities/:easyNumber',
    breadcrumb: 'Entity details',
  },
  {
    path: '/portfolios/:portfolioId/entities/:entityId/instruments/:instrumentId',
    breadcrumb: 'Instrument details',
  },
  {
    path: '/portfolios/:portfolioId/entities/:entityId/instruments/:instrumentId/announcements/:announcementId',
    breadcrumb: 'Announcement',
  },
  {
    path: '/portfolios/:portfolioId/entities/:entityId/announcements/:announcementId',
    breadcrumb: 'Announcement',
  },
  {
    path: '/portfolios/:portfolioId/entities/:entityId',
    breadcrumb: 'Entity details',
  },
  {
    path: '/portfolios/:portfolioId/instruments/:instrumentId',
    breadcrumb: 'Instruments details',
  },
  {
    path: '/portfolios/:portfolioId/announcements/:announcementId',
    breadcrumb: 'Announcement',
  },
  {
    path: '/portfolios/:portfolioId',
    breadcrumb: PortfolioItemsBreadcrumbs,
  },
  {
    path: '/portfolios',
    breadcrumb: 'Portfolios',
  },
  // /Portfolio
  // Related rating coverage related
  {
    path: '/credit-rating-coverage/related/entities/:entityId/instruments/:instrumentId',
    breadcrumb: 'Instrument details',
  },
  {
    path: '/credit-rating-coverage/related/entities/:entityId/instruments/:instrumentId/announcements/:announcementId',
    breadcrumb: 'Announcement',
  },
  {
    path: '/credit-rating-coverage/related/entities/:entityId/announcements/:announcementId',
    breadcrumb: 'Announcement',
  },
  {
    path: '/credit-rating-coverage/related/entities/:entityId',
    breadcrumb: 'Entity details',
  },
  {
    path: '/credit-rating-coverage/related',
    breadcrumb: 'Related credit rating coverage',
  },
  {
    path: '/credit-rating-coverage-list',
    breadcrumb: 'Credit Rating Coverage',
  },
  {
    path: '/credit-rating-coverage-list/:countryId',
    breadcrumb: CreditRatingCoverageTableCountryBreadcrumb,
  },
  // /Related rating coverage related
  // Related rating coverage industry
  {
    path: '/credit-rating-coverage/industry/entities/:entityId/instruments/:instrumentId',
    breadcrumb: 'Instrument details',
  },
  {
    path: '/credit-rating-coverage/industry/entities/:entityId/instruments/:instrumentId/announcements/:announcementId',
    breadcrumb: 'Announcement',
  },
  {
    path: '/credit-rating-coverage/industry/entities/:entityId/announcements/:announcementId',
    breadcrumb: 'Announcement',
  },
  {
    path: '/credit-rating-coverage/industry/announcements/:announcementId',
    breadcrumb: 'Announcement',
  },
  {
    path: '/credit-rating-coverage/industry/entities/:entityId',
    breadcrumb: 'Entity details',
  },
  {
    path: '/credit-rating-coverage/industry',
    breadcrumb: 'Industry credit rating coverage',
  },
  // /Related rating coverage industry
  // Related rating coverage
  {
    path: '/credit-rating-coverage/:businessLine/entities/:entityId/instruments/:instrumentId',
    breadcrumb: 'Instrument details',
  },
  {
    path: '/credit-rating-coverage/:businessLine/entities/:entityId/instruments/:instrumentId/announcements/:announcementId',
    breadcrumb: 'Announcement',
  },
  {
    path: '/credit-rating-coverage/:businessLine/entities/:entityId/announcements/:announcementId',
    breadcrumb: 'Announcement',
  },
  {
    path: '/credit-rating-coverage/:businessLine/entities/:entityId',
    breadcrumb: 'Entity details',
  },
  {
    path: '/credit-rating-coverage/:businessLine',
    breadcrumb: CoverageListBreadcrumbs(
      'Credit rating coverage',
      'businessLine',
      (businessLine: keyof typeof businessLines) => businessLines[businessLine],
    ),
  },
  {
    path: '/esg-coverage/:region/entities/:entityId',
    breadcrumb: 'Entity details',
  },
  {
    path: '/esg-coverage/:region',
    breadcrumb: CoverageListBreadcrumbs(
      'ESG coverage',
      'region',
      (region: keyof typeof regions) => {
        const regs = useFilterOptions();

        if (!region.includes('i-')) {
          return regions[region];
        }

        return (
          regs.data?.industries.find((industry) => region.includes(industry.industryCode))
            ?.industryName || 'Industry'
        );
      },
    ),
  },
  // /Related rating coverage
  {
    path: '/not-found',
    breadcrumb: 'Not found',
  },
  {
    path: '/error-page',
    breadcrumb: 'Error',
  },
  {
    path: '/covered-bonds',
    breadcrumb: 'Covered bonds',
  },
  {
    path: '/admin-panel',
    breadcrumb: 'Admin panel',
  },
  {
    path: '/admin-panel/:ratingType',
    breadcrumb: SubscriptionRatingsBreadcrumbs,
  },
  {
    path: '/admin-panel/:ratingType/ratings/:ratingId',
    breadcrumb: RSRRatingUsersBreadcrumbs,
  },
  {
    path: '/admin-panel/:ratingType/ratings',
    breadcrumb: 'Ratings',
  },
  {
    path: '/admin-panel/:ratingType/users',
    breadcrumb: 'Users',
  },
];
